module.exports = __webpack_public_path__ + "static/media/header-960.1e58ddfc.webp";